import { render, staticRenderFns } from "./CommissionsPastFutureChart.vue?vue&type=template&id=3c5d6fb0"
import script from "./CommissionsPastFutureChart.vue?vue&type=script&lang=js"
export * from "./CommissionsPastFutureChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports